module.exports = __webpack_public_path__ + "img/physicalTests.bb2b04ac.svg";